import React from 'react'
import classNames from 'classnames'
import { Button } from '@mytours/components'
import strings from '../../../../../strings'

import './styles.less'

interface Props {
	className?: string
	ariaLabel?: string
	onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const MapButton: React.FC<Props> = ({ className, ariaLabel = strings.open_map, onClick }) => (
	<Button
		variant="clear"
		textColor="var(--title-color)"
		className={classNames('map-button', className)}
		aria-label={ariaLabel}
		onClick={onClick}
	>
		<i className="fal fa-map-marked-alt" />
	</Button>
)

export default React.memo(MapButton)
